import * as axiosService from "./axiosService";

//Document upload api
export const uploadDocument = (payload, config) => {
  return axiosService.Upload(
    process.env.REACT_APP_COMMON_API_URL +
      `/UploadDocument/UploadDocumentPartition`,
    payload,
    config
  );
};

export const uploadDocumentV2 = (payload, config) => {
  return axiosService.PostFile(
    process.env.REACT_APP_COMMON_API_URL +
      `/UploadDocument/UploadDocumentPartitionV2`,
    payload,
    config
  );
};

//get base64 string from file
export const toBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

// OCR FILE UPLOAD From Library
export const ocrFileUploadService = (payload) => {
  debugger;
  return axiosService.Post(
    "https://prod-ml.fracto.tech//upload-file-smart-ocr",
    payload,
    true,
    {
      "Content-Type": "multipart/form-data",
      "x-api-key": "TRU-TRU-6B7E98-5THKDU-YCWUKBHV",
    }
  );
};

// Custom OCR API from Backend
export const ocrCustomFileUploadService = (payload, config) => {
  console.log("payload", payload);
  return axiosService.PostFile(
    process.env.REACT_APP_COMMON_API_URL +
      `/UploadDocument/UploadFractoOCRFiles`,
    payload,
    config
  );
};

export const ocrInvoiceFileUpload = (payload, config) => {
  console.log("payload", payload);
  return axiosService.PostFileAuth(
    process.env.REACT_APP_COMMON_AUTH_API_URL +
      `/VendorInvoice/UploadInvoiceOCRFiles`,
    payload,
    config
  );
};
